import React, {useEffect, useState, useCallback} from "react";
import PropTypes from  "prop-types";
import { RateAssignment as RateAssignmentApi } from '../../../../api/services/next';
import { useTextResources } from '../../../../language';
import { Form } from 'semantic-ui-react';
import EditEntityPopup from "../../../../components/shared/EditEntityPopup";
import CustomerDropDown from "../../../../components/shared/CustomerDropDown";
import CustomerGroupDropDown from "../../../../components/shared/CustomerGroupDropDown";
import useSafeState from "../../../../hooks/useSafeState";
import { useLoader } from "../../../../hooks/useLoader";

const AddMultipleRateAssignmentsModal = ({
	open,
	rateId,
	onClose,
	createMultipleRateAssignments,
}) => {
	const loader = useLoader();
	const [customers, setCustomers] = useSafeState([]);
	const [customerGroups, setCustomerGroups] = useSafeState([]);
	const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
	const [selectedCustomerGroupIds, setSelectedCustomerGroupIds] = useState([]);

	const loadOptions = useCallback(async () => {
		try {
			loader(true);
			const {
				customers: newCustomers,
				customerGroups: newCustomerGroups,
			} = await RateAssignmentApi.GetAddRateAssignmentsOptions({
				RateId: rateId,
			});
			setCustomers(newCustomers);
			setCustomerGroups(newCustomerGroups);
		} catch {
			setCustomers([]);
			setCustomerGroups([]);
		}
		finally {
			loader(false);
		}
	}, [loader, rateId, setCustomerGroups, setCustomers]);

	useEffect(() => {
		if (open) {
			loadOptions();
		}
		return () => {
			setSelectedCustomerIds([]);
			setSelectedCustomerGroupIds([]);
			setCustomers([]);
			setCustomerGroups([]);
		};
	}, [loadOptions, open, setCustomerGroups, setCustomers]);

	const handleSave = useCallback(async () => {
		await createMultipleRateAssignments({
			RateId: rateId,
			CustomerIds: selectedCustomerIds,
			CustomerGroupIds: selectedCustomerGroupIds,
		});
	}, [createMultipleRateAssignments, rateId, selectedCustomerGroupIds, selectedCustomerIds]);

	const text = useTextResources();

	return (
		<EditEntityPopup
            open={open}
            isCreate
            header={text('InsertMultipleCustomers')}
            onClose={onClose}
            onSave={handleSave}
            closeOnDimmerClick={false}
        >
            <Form>
				<Form.Field
					control={CustomerDropDown}
					label={text("Customer")}
					data={customers}
					placeholder={text('Customer')}
					multiple
					clearable
					onChange={setSelectedCustomerIds}
				/>
				<Form.Field
					control={CustomerGroupDropDown}
					label={text("CustomerGroup")}
					data={customerGroups}
					placeholder={text('CustomerGroup')}
					multiple
					clearable
					onChange={setSelectedCustomerGroupIds}
				/>
            </Form>
        </EditEntityPopup>
	);
}

AddMultipleRateAssignmentsModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	rateId: PropTypes.number.isRequired,
	createMultipleRateAssignments: PropTypes.func,
};

AddMultipleRateAssignmentsModal.defaultProps = {
	createMultipleRateAssignments: () => {},
};

export default AddMultipleRateAssignmentsModal;
